module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-baby-IT.5eb2ab8.png";